import { IOfferModeWithFSecure } from "@nju/data-access-portal-offers";
import { Icon } from "@nju/icons";
import { IScope } from "@nju/scope";
import { BlockText, Separator, Text } from "@nju/ui";
import { formatPrice } from "@nju/utils";
import { ChangePaymentButton } from "../../ChangePaymentButton";
import { ChangePaymentPendingInfo } from "../../ChangePaymentPendingInfo";

interface IDigitalWalletInsufficientFundsProps {
  amount: number;
  isPending: boolean;
  showChangePaymentButton: boolean;
  openModal: () => void;
  mode: IOfferModeWithFSecure;
  variant: IScope;
  userId: string | undefined;
}

export function DigitalWalletInsufficientFunds({
  amount,
  isPending,
  showChangePaymentButton,
  openModal,
  mode,
  variant,
  userId,
}: IDigitalWalletInsufficientFundsProps) {
  return (
    <div className="flex flex-col">
      <div className="flex">
        <div className="pr-2 shrink-0">
          <Icon height={28} name="wallet" tone="accent" width={28} />
        </div>
        <div className="items-center flex justify-between flex-1">
          <Text weight="bold">Twoje środki</Text>
          <Text tone="alert" weight="bold">
            {formatPrice(amount)} zł
          </Text>
        </div>
      </div>
      <Separator size="xxs" tone="invisible" />
      <div className="flex">
        <div className="flex gap-1 flex-col">
          {variant === "portal" && showChangePaymentButton && (
            <div className="pl-8">
              <ChangePaymentButton
                isPending={isPending}
                mode={mode}
                openModal={openModal}
                tone="neutral"
                userId={userId}
              />
            </div>
          )}
          <Separator size="xxs" tone="invisible" />
          <div className="flex items-start">
            <div className="flex pr-2 shrink-0">
              <Icon
                height={19}
                name="exclamation-circle"
                tone="alert"
                width={19}
              />
            </div>
            <BlockText tone="alert">
              Nie masz wystarczającej ilości środków. Dodaj je, by włączyć
              usługę.
            </BlockText>
          </div>
          {variant === "portal" && isPending && (
            <ChangePaymentPendingInfo tone="accent" />
          )}
        </div>
      </div>
    </div>
  );
}
